var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor-book-fill-view" },
    [
      _c(
        "div",
        { staticClass: "editor-book-fill-view-header" },
        [
          _c("span", { staticClass: "editor-book-fill-view-header-step" }, [
            _vm._v(
              _vm._s(_vm.$t("views.editorBookFill.step")) +
                " " +
                _vm._s(_vm.stepSelected) +
                "/2"
            ),
          ]),
          _c("IconComponent", { on: { click: _vm.onCloseClick } }, [
            _vm._v("close"),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "editor-book-fill-view-body" }, [
        _c("div", { staticClass: "editor-book-fill-view-body-header" }, [
          _vm._v(
            _vm._s(
              _vm.stepSelected === 1
                ? _vm.$t("views.editorBookFill.pagePrompt")
                : _vm.$t("views.editorBookFill.marginPrompt")
            )
          ),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.stepSelected === 1,
                expression: "stepSelected === 1",
              },
            ],
            staticClass: "editor-book-fill-view-pages-container",
          },
          [
            _c(
              "div",
              { staticClass: "editor-book-fill-view-pages-selected-header" },
              [
                _vm._v(
                  _vm._s(_vm.$t("views.editorBookFill.pageDescription")) + " "
                ),
                _c(
                  "span",
                  {
                    staticClass:
                      "editor-book-fill-view-pages-selected-header-value",
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.selectedPage.innerPagesAfterAutoFill) +
                        " " +
                        _vm._s(_vm.$t("views.editorBookFill.pages"))
                    ),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "editor-book-fill-view-pages-selected-per-page" },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "views.editorBookFill.perPage." + _vm.selectedPage.id
                    )
                  )
                ),
              ]
            ),
            _c("img", {
              staticClass: "editor-book-fill-view-pages-selected-image",
              attrs: { src: _vm.selectedPageImage },
            }),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.stepSelected === 1,
                expression: "stepSelected === 1",
              },
            ],
            staticClass: "editor-book-fill-view-pages-slider-container",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "editor-book-fill-view-pages-slider-icon-container",
              },
              [
                _c("IconComponent", [_vm._v("less_pages")]),
                _c(
                  "span",
                  {
                    staticClass: "editor-book-fill-view-pages-slider-icon-text",
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("views.editorBookFill.slider.lessPages"))
                    ),
                  ]
                ),
              ],
              1
            ),
            _c("InputSliderComponent", {
              attrs: {
                max: _vm.pages.length - 1,
                min: 0,
                "show-steps": true,
                "show-value": false,
                "track-height": 12,
                "thumb-color": "--accent1",
                value: _vm.sliderValue,
              },
              on: { input: _vm.onSliderInput },
            }),
            _c(
              "div",
              {
                staticClass:
                  "editor-book-fill-view-pages-slider-icon-container",
              },
              [
                _c("IconComponent", [_vm._v("more_pages")]),
                _c(
                  "span",
                  {
                    staticClass: "editor-book-fill-view-pages-slider-icon-text",
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("views.editorBookFill.slider.morePages"))
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.stepSelected === 2 && !_vm.isMobile,
                expression:
                  "\n\t\t\t\tstepSelected === 2\n\t\t\t\t&& !isMobile\n\t\t\t",
              },
            ],
            staticClass: "editor-book-fill-view-margins-container",
          },
          _vm._l(_vm.margins, function (margin) {
            return _c(
              "div",
              {
                key: margin.id,
                staticClass: "editor-book-fill-view-margin",
                class: {
                  "editor-book-fill-view-margin-selected":
                    margin.id === _vm.selectedMargin.id,
                },
                on: {
                  click: function ($event) {
                    return _vm.onMarginClick(margin.id)
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "editor-book-fill-view-margin-image",
                  attrs: { src: _vm.getMarginImage(margin.id) },
                }),
                _c(
                  "span",
                  { staticClass: "editor-book-fill-view-margin-type" },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t("views.editorBookFill.marginId." + margin.id)
                      ) +
                        " " +
                        _vm._s(_vm.$t("views.editorBookFill.margin"))
                    ),
                  ]
                ),
              ]
            )
          }),
          0
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.stepSelected === 2 && _vm.isMobile,
                expression:
                  "\n\t\t\t\tstepSelected === 2\n\t\t\t\t&& isMobile\n\t\t\t",
              },
            ],
            staticClass: "editor-book-fill-view-margins-container",
          },
          [
            _c("div", { staticClass: "editor-book-fill-view-margin" }, [
              _c("img", {
                staticClass: "editor-book-fill-view-margin-image",
                attrs: { src: _vm.getMarginImage(_vm.selectedMargin.id) },
              }),
              _c("span", { staticClass: "editor-book-fill-view-margin-type" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "views.editorBookFill.marginId." + _vm.selectedMargin.id
                    )
                  ) +
                    " " +
                    _vm._s(_vm.$t("views.editorBookFill.margin"))
                ),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "editor-book-fill-view-margins-buttons-toggle-container",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "editor-book-fill-view-margins-buttons-toggle",
                  },
                  _vm._l(_vm.margins, function (margin) {
                    return _c(
                      "button",
                      {
                        key: margin.id,
                        staticClass:
                          "editor-book-fill-view-margins-button-toggle",
                        class: {
                          "editor-book-fill-view-margins-button-toggle-selected":
                            margin.id === _vm.selectedMargin.id,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onMarginClick(margin.id)
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "views.editorBookFill.marginIdChoose." + margin.id
                            )
                          )
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ]
        ),
      ]),
      _c("divider", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isMobile,
            expression: "!isMobile",
          },
        ],
        staticClass: "divider horizontal full",
      }),
      _c(
        "div",
        { staticClass: "editor-book-fill-view-footer" },
        [
          _c("PriceView", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.stepSelected === 1,
                expression: "stepSelected === 1",
              },
            ],
            attrs: {
              cents: _vm.selectedPage.price * 100,
              currency: _vm.currencyModel.id,
            },
          }),
          _c(
            "div",
            {
              staticClass: "editor-book-fill-view-footer-buttons",
              class: {
                "editor-book-fill-view-footer-buttons-full-width":
                  _vm.stepSelected === 2 && _vm.isMobile,
                "editor-book-fill-view-footer-buttons-last-step":
                  _vm.stepSelected === 2,
              },
            },
            [
              _c(
                "ButtonComponent",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.stepSelected === 1,
                      expression: "stepSelected === 1",
                    },
                  ],
                  attrs: {
                    width: !_vm.isMobile ? 275 : undefined,
                    color: "secondary",
                  },
                  on: { click: _vm.onCloseClick },
                },
                [_vm._v(_vm._s(_vm.$t("views.editorBookFill.buttons.decide")))]
              ),
              _c(
                "ButtonComponent",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.stepSelected === 1,
                      expression: "stepSelected === 1",
                    },
                  ],
                  attrs: { width: !_vm.isMobile ? 275 : 120 },
                  on: { click: _vm.onApplyClick },
                },
                [_vm._v(_vm._s(_vm.$t("views.editorBookFill.buttons.apply")))]
              ),
              _c(
                "ButtonComponent",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.stepSelected === 2,
                      expression: "stepSelected === 2",
                    },
                  ],
                  attrs: {
                    width: !_vm.isMobile ? 275 : "100%",
                    color: "secondary",
                  },
                  on: { click: _vm.onBackClick },
                },
                [_vm._v(_vm._s(_vm.$t("views.editorBookFill.buttons.back")))]
              ),
              _c(
                "ButtonComponent",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.stepSelected === 2,
                      expression: "stepSelected === 2",
                    },
                  ],
                  attrs: { width: !_vm.isMobile ? 275 : "100%" },
                  on: { click: _vm.onSelectClick },
                },
                [_vm._v(_vm._s(_vm.$t("views.editorBookFill.buttons.select")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }